export enum MessageType {
  INITIAL,
  END_OF_INITIAL, //inital tabel has been send, no data
  INSERT,
  DELETE,
  EXPUNGE,
  UPDATE,
  REPLACE,
  ORDER
}
